module.exports = __webpack_public_path__ + "static/media/DIRECTV_GO_LOGO_HORIZONTAL_RGB.95c249e3.svg";